import styled from 'styled-components';

export const U21Asterisk = () => {
  return <Asterisk>&thinsp;*</Asterisk>;
};

const Asterisk = styled.b`
  color: ${(props) => props.theme.palette.error.main};
`;
